import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Typography } from 'antd';
import { colorsPalette } from '../../styles/colors-palette';
const { Link: AntLink } = Typography;

type Padding = `${number}px` | 0;

interface CustomStyles {
  paddingBottom?: Padding;
  fontSize?: number;
  color?: Color;
  hoverColor?: Color;
}

interface LinkProps {
  onClick?: () => void;
  href?: string;
  underline?: boolean;
  target?: Target;
  className?: string;
  children?: React.ReactNode;
  customStyles?: CustomStyles;
}

type Target = '_blank' | '_self' | '_parent' | '_top';

function Link({
  onClick,
  children,
  className,
  href,
  target,
  underline,
  customStyles,
}: LinkProps): JSX.Element {
  return (
    <Styled
      href={href}
      className={className}
      onClick={onClick}
      target={target}
      underline={underline}
      customstyles={customStyles}
    >
      {children}
    </Styled>
  );
}

const Styled = styled(AntLink)<{ customstyles?: CustomStyles }>`
  &.ant-typography {
    padding-bottom: ${props => props.customstyles?.paddingBottom};
    text-decoration: underline;
    color: ${props => props.customstyles?.color || colorsPalette.dustyBlue500};
    font-size: ${props =>
      props.customstyles?.fontSize ? `${props.customstyles?.fontSize}px` : undefined};

    &:hover {
      color: ${props => props.customstyles?.hoverColor || colorsPalette.dustyBlue600} !important;
    }
  }
`;

export default Link;
